<template>
    <Head>
        <title>Lift-Check</title>
        <meta property="og:title" content="Lift-Check" />
        <meta
            head-key="description"
            name="description"
            content="Durchlaufen Sie unseren kostenlosen Treppenlift-Check und erhalten Sie in wenigen Minuten eine individuelle Einschätzung. **Keywords:** Treppenlift-Check, Kostenlose Beratung, Treppenlift-Angebote"
        />
    </Head>

    <FunnelMini :eid="eid" @next-step-clicked="handleNextStepClicked" />

    <CTASection />
    <!-- <FunnelFAQSection :faqs="faqs" /> -->
</template>

<script setup>
import { ref } from 'vue'
import { Head } from '@inertiajs/vue3'
import FunnelLayout from '@/Layouts/FunnelLayout.vue'
import CTASection from '@/Components/Sections/CTASection.vue'
import FunnelMini from '../../Components/Stairlift/FunnelMini.vue'

defineProps({
    eid: String,
})

defineOptions({
    layout: FunnelLayout,
})

let showDiv = ref(1)

const handleNextStepClicked = (arrayLength) => {
    showDiv.value = arrayLength
}
</script>
